export const SERVER_URL = 'https://railways.makemytrip.com/api';
export const MMT_SERVER_URL = 'https://www.makemytrip.com/api';
// export const SERVER_URL = 'http://localhost:3001/api';
